<div class="channelDiv">
    <div class="channelSubscriptionDiv">
        <div class="logoAndChannel">
            <img src="../../assets/img/logoSubscriptionPart.png" alt="logo">
            <div class="channelAndIcon">
                <div class="channelSubscription"> Metl.tv Channel Subscribtion</div>
                <img src="../../assets/img/rocket.png" alt="logo">
            </div>
        </div>
    </div>
    <div class="backAndDetailsDiv">
        <div class="backDiv" (click)="backPage()">
            <img src="../../assets/img/backSign.png" alt="backSign">
            <div class="back">Back</div>
        </div>
        <div class="detailsDiv">Details</div>
        <div></div>
    </div>
    <div class="cardDetailed" *ngIf="plan">
        <div class="CardDetailedTitleAndLogo">
            <div class="CardDetailedLogo">
                <img [src]='planIcon' alt="goldFrame">
            </div>
            <div class="CardDetailedTitle">
                {{plan[0]?.custom_fields?.badgeColor | capitalizeAddSpaces}} Trier
            </div>
        </div>
        <div class="cardsTotal">
            <div class="cardTotalDiv" *ngFor="let item of plan;let i = index">
                <div class="cardDiv1">{{item.name}}</div>
                <div class="cardDiv2">
                    <img *ngIf="i === 0"
                         src="../../assets/img/freeGreenIcon.png" alt="freeIcon">
                    <img *ngIf="i === 1"
                         [src]='planIcon' alt="goldIcon">
                    <img *ngIf="(planName === 'silver' || planName === 'gold') && i === 2"
                         src="../../assets/img/colorCircle.png" alt="colorCircle">
                    <img *ngIf="(planName === 'gold') && i === 3"
                         src="../../assets/img/sadIcon.png" alt="sadIcon">
                    <img *ngIf="(planName === 'gold') && i === 3"
                         class="coolImgClassName"
                         src="../../assets/img/coolIcon.png" alt="coolIcon">
                </div>
                <div class="cardDiv3">{{item.description}}</div>
            </div>
            <!--            <div class="cardTotalDiv">-->
            <!--                <div class="cardDiv1">{{plan[0].name}}</div>-->
            <!--                <div class="cardDiv2">-->
            <!--                    <img [src]='planIcon' alt="goldIcon">-->
            <!--                </div>-->
            <!--                <div class="cardDiv3">{{plan[0].description}}</div>-->
            <!--            </div>-->
            <!--            <div class="cardTotalDiv" *ngIf="planName === 'silver' || planName === 'gold'">-->
            <!--                <div class="cardDiv1">Custom Chat Username Colors</div>-->
            <!--                <div class="cardDiv2">-->
            <!--                    <img src="../../assets/img/colorCircle.png" alt="colorCircle">-->
            <!--                </div>-->
            <!--                <div class="cardDiv3">{{plan[0].description}}-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="cardTotalDiv" *ngIf="planName === 'gold'">-->
            <!--                <div class="cardDiv1">Custom Chat Username Colors</div>-->
            <!--                <div class="cardDiv2">-->
            <!--                    <img src="../../assets/img/sadIcon.png" alt="sadIcon">-->
            <!--                    <img class="coolImgClassName" src="../../assets/img/coolIcon.png" alt="coolIcon">-->
            <!--                </div>-->
            <!--                <div class="cardDiv3">User gets custom emojis that other users do not have access to for the live stream-->
            <!--                    chat-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
        <div class="subscriptionDivs">
            <div class="subscriptionLeftPart">
                <div class="subscriptionLeftPart1" *ngIf="plan">
                    {{plan[0]?.custom_fields?.badgeColor | capitalizeAddSpaces}}
                </div>
                <div class="select">
                    <select (change)="onChange($event.target)" class="custom_select">
                        <option value="" class="custom_select_option">Select for sale</option>
                        <option value="3" class="custom_select_option">3% off for 3 months subscription</option>
                        <option value="7" class="custom_select_option">7% off for 6 months. subscription</option>
                        <option value="11" class="custom_select_option"> 11% off for a year. subscriptions</option>
                    </select>
                </div>
                <div class="subscriptionLeftPart2">
                    <div class="sale_cost" *ngIf="totalCost">
                        <sub class="sale">For {{discountMonths}} {{discountMonths === 1 ? 'Year ' : 'Months ' }}</sub>
                        <p class="sale_cost_text">
                            ${{totalCost}}
                        </p>
                    </div>
                    <div class=" subscriptionLeftDiv2">$ {{constantCost}} {{totalCost ? ' ' : ' / Month'}}</div>
                </div>
            </div>
            <button class="subscribeBtn" (click)="openModalPayment()">Subscribe</button>
        </div>
    </div>
    <div class="belowGreyDiv"></div>
</div>
